<template>
  <div class="">
    <span class="text-center txtStyle">نما پشت</span>
    <!--ران چپ 27-->
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <svg class="vector" width="30" height="69" viewBox="0 0 30 69" @click="backPartClick(27)" :fill="backFill27"
          xmlns="http://www.w3.org/2000/svg" v-on="on" v-bind="attrs">
          <path
            d="M0.657227 0.307953C0.657227 0.307953 3.76452 12.0158 14.0574 13.4585C20.5772 14.374 26.5421 11.4887 28.0402 9.79629C29.5384 8.10392 28.7615 14.9844 28.9558 21.7816C29.15 28.5787 29.0667 29.3833 28.2067 39.5652C27.3466 49.7472 26.9582 54.3249 27.0137 57.7373C27.0692 61.1498 27.0969 62.6202 27.0969 62.6202C27.0969 62.6202 27.957 65.5333 25.9594 66.2824C23.9619 67.0315 21.0766 68.4464 15.5833 68.0857C10.0901 67.7251 6.95504 66.9482 6.78858 65.9217C6.62211 64.8952 3.51483 41.2021 3.51483 41.2021C3.51483 41.2021 1.0179 29.2169 0.851436 22.17C0.684974 15.1231 0.657227 0.307953 0.657227 0.307953Z"
            stroke="#212121" stroke-width="0.814669" />
        </svg>
      </template>
      <span>{{ tooltipText() }}</span>
    </v-tooltip>

    <!--ران راست 28-->

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <svg class="vector2" v-bind="attrs" v-on="on" width="30" height="69" viewBox="0 0 30 69"
          @click="backPartClick(28)" :fill="backFill28" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M29.0554 0.307953C29.0554 0.307953 25.9481 12.0158 15.6552 13.4585C9.13541 14.374 3.17054 11.4887 1.67238 9.79629C0.174222 8.10392 0.951047 14.9844 0.756842 21.7816C0.562636 28.5787 0.645854 29.3833 1.50591 39.5652C2.36596 49.7472 2.75438 54.3249 2.6989 57.7373C2.64341 61.1498 2.61565 62.6202 2.61565 62.6202C2.61565 62.6202 1.75561 65.5333 3.75315 66.2824C5.7507 67.0315 8.63603 68.4464 14.1293 68.0857C19.6225 67.7251 22.7575 66.9482 22.924 65.9217C23.0905 64.8952 26.1978 41.2021 26.1978 41.2021C26.1978 41.2021 28.6947 29.2169 28.8612 22.17C29.0276 15.1231 29.0554 0.307953 29.0554 0.307953Z"
            stroke="#212121" stroke-width="0.814669" />
        </svg>
      </template>
      <span>{{ tooltipText(28) }}</span>
    </v-tooltip>
    <!--باسن چپ 25-->
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <svg class="vector3" width="30" height="56" viewBox="0 0 30 56" @click="backPartClick(25)" :fill="backFill25"
          xmlns="http://www.w3.org/2000/svg" v-on="on" v-bind="attrs">
          <path
            d="M4.1528 7.90941C4.1528 7.90941 3.65341 14.4569 3.15402 17.0093C2.65464 19.5617 1.01776 31.2141 0.906786 32.7122C0.795811 34.2104 0.490631 38.8436 1.7391 43.1993C2.98756 47.5551 3.95859 52.7986 10.6448 54.7407C17.331 56.6828 23.1572 55.7395 25.4599 52.8541C27.7626 49.9688 29.3718 48.4152 29.0111 39.8978C29.0111 39.8978 29.455 32.0464 29.455 30.7147C29.455 29.383 30.0931 26.8861 27.3742 27.0803C24.6554 27.2745 22.6301 21.3373 22.4636 19.8392C22.2971 18.341 22.3526 14.3182 22.6023 12.8755C22.852 11.4329 23.6011 8.29782 20.8822 5.41248C18.1633 2.52714 14.7231 -0.829837 9.22988 1.30642C3.32048 5.13505 4.1528 7.90941 4.1528 7.90941Z"
            stroke="#212121" stroke-width="0.814669" />
        </svg>
      </template>
      <span>{{ tooltipText(25) }}</span>
    </v-tooltip>

    <!--باسن راست 26-->
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <svg class="vector4" width="30" height="56" viewBox="0 0 30 56" @click="backPartClick(26)" :fill="backFill26"
          xmlns="http://www.w3.org/2000/svg" v-on="on" v-bind="attrs">
          <path
            d="M25.9523 7.90941C25.9523 7.90941 26.4517 14.4569 26.9511 17.0093C27.4504 19.5617 29.0873 31.2141 29.1983 32.7122C29.3093 34.2104 29.6145 38.8436 28.366 43.1993C27.1175 47.5551 26.1465 52.7986 19.4603 54.7407C12.7741 56.6828 6.94789 55.7395 4.64517 52.8541C2.34245 49.9688 0.7333 48.4152 1.09397 39.8978C1.09397 39.8978 0.650076 32.0464 0.650076 30.7147C0.650076 29.383 0.011972 26.8861 2.73085 27.0803C5.44973 27.2745 7.19758 21.3373 7.36404 19.8392C7.53051 18.341 7.47502 14.3182 7.22533 12.8755C6.97563 11.4329 6.22656 8.29782 8.94544 5.41248C11.6643 2.52714 15.382 -0.829837 20.8752 1.30642C26.7846 5.13505 25.9523 7.90941 25.9523 7.90941Z"
            stroke="#212121" stroke-width="0.814669" />
        </svg>
      </template>
      <span>{{ tooltipText(26) }}</span>
    </v-tooltip>
    <!-- until here -->
    <!--پایین کمر چپ 22-->
    <!-- <v-tooltip top>
      <template v-slot:activator="{ on, attrs }"></template>
      <span>{{tooltipText()}}</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }"></template>
      <span>{{tooltipText()}}</span>
    </v-tooltip> -->
    <svg class="vector5" width="22" height="26" viewBox="0 0 22 26" @click="backPartClick(22)" :fill="backFill22"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.20331 2.05238C1.20331 2.05238 0.260027 17.4224 0.731669 20.1413C1.20331 22.8601 4.58804 16.6456 10.8858 17.3669C14.7977 18.5044 16.1294 22.4995 17.5166 23.637C18.9038 24.7745 20.2077 26.4113 20.3464 23.637C20.4852 20.8626 20.4297 6.40814 20.6239 4.88224C20.8181 3.35634 21.1787 0.609726 21.1787 0.609726C21.1787 0.609726 7.47338 5.21516 1.20331 2.05238Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--پایین کمر راست 23-->
    <svg class="vector6" width="22" height="25" viewBox="0 0 22 25" @click="backPartClick(23)" :fill="backFill23"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.3426 1.52398C21.3426 1.52398 22.3137 16.7553 21.842 19.3077C21.3704 21.8601 17.8747 15.2016 11.3827 15.8675C7.35982 16.9495 5.97264 21.5272 4.52997 22.5814C3.0873 23.6357 1.72786 25.1893 1.61688 22.5814C1.50591 19.9735 1.53365 5.60231 1.33945 4.18738C1.14524 2.77246 0.756836 0.192291 0.756836 0.192291C0.756836 0.192291 14.8784 4.49255 21.3426 1.52398Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کمر راست 21-->
    <svg class="vector7" width="35" height="84" viewBox="0 0 35 84" @click="backPartClick(21)" :fill="backFill21"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.45313 4.35907C4.45313 4.35907 4.46387 0.526846 6.78432 1.59867C9.10477 2.67049 9.78765 2.39281 9.78434 5.72494C9.78103 9.05706 10.1577 25.1464 10.5813 30.0994C11.0049 35.0523 12.0585 45.2554 16.3023 47.193C20.5461 49.1307 23.7101 41.5883 23.7101 41.5883C23.7101 41.5883 25.0001 37.121 28.0279 36.4703C31.0558 35.8195 32.6174 34.6176 32.3486 38.9324C32.0798 43.2471 31.8325 48.0886 29.7067 54.5336C27.5809 60.9786 28.0212 67.7079 28.0212 67.7079C28.0212 67.7079 27.7232 78.1325 24.1502 81.0823C20.5772 84.032 15.0536 83.3959 5.96541 81.8219C2.28664 80.8053 4.76014 71.986 4.85723 69.5941C4.95431 67.2022 4.57812 43.6159 4.48521 40.6487C4.44773 37.6792 4.45313 4.35907 4.45313 4.35907Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کمر چپ 20-->
    <svg class="vector8" width="29" height="83" viewBox="0 0 29 83" @click="backPartClick(20)" :fill="backFill20"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.1453 3.5768C28.1453 3.5768 28.1453 -0.251826 25.8148 0.802432C23.4844 1.85669 22.7908 1.607 22.7908 4.90849C22.7908 8.20998 22.3469 24.329 21.903 29.2674C21.4591 34.2058 20.3771 44.4155 16.1046 46.3575C11.832 48.2996 8.72476 40.7255 8.72476 40.7255C8.72476 40.7255 7.44855 36.2588 4.42449 35.593C1.40043 34.9271 -0.153215 33.7341 0.0687344 38.0344C0.290684 42.3347 0.540382 47.1898 2.6489 53.6263C4.75742 60.0629 4.28577 66.8046 4.28577 66.8046C4.28577 66.8046 4.53546 77.2362 8.11439 80.177C11.6933 83.1178 17.1866 82.5075 26.2865 80.9816C29.9764 79.9828 27.535 71.1326 27.424 68.7466C27.313 66.3607 27.7846 42.7786 27.8956 39.81C28.0621 36.8969 28.1453 3.5768 28.1453 3.5768Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--سر شانه چپ 3-->
    <svg class="vector9" width="45" height="56" viewBox="0 0 45 56" @click="backPartClick(3)" :fill="backFill3"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.16958 41.4853C2.16958 41.4853 13.1006 41.4298 17.4286 43.9268C21.7566 46.4237 22.8664 46.6456 27.0002 52.6383C31.134 58.6309 33.1593 52.7215 33.1593 52.7215C33.1593 52.7215 36.9879 31.2479 34.4355 21.6209C34.4355 21.6209 29.6081 15.1288 34.4355 13.5752C37.3147 12.653 40.1087 11.4834 42.7863 10.0795C42.7863 10.0795 45.9491 8.08195 42.8695 4.66948C39.79 1.25701 41.2049 -1.26767 32.8541 2.67193C23.1993 9.1362 11.6024 14.3798 9.13324 16.9322C6.66406 19.4846 2.66897 22.3422 1.00435 38.4335C1.00435 38.4058 0.421731 42.3454 2.16958 41.4853Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--سر شانه راست 4-->
    <svg class="vector10" width="45" height="56" viewBox="0 0 45 56" @click="backPartClick(4)" :fill="backFill4"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42.9478 41.4852C42.9478 41.4852 32.0168 41.4298 27.6888 43.9267C23.3608 46.4236 22.251 46.6456 18.1172 52.6382C13.9834 58.6308 11.9581 52.7214 11.9581 52.7214C11.9581 52.7214 8.12949 31.2478 10.6819 21.6208C10.6819 21.6208 15.5093 15.1288 10.6819 13.5751C7.80267 12.653 5.00864 11.4834 2.33107 10.0794C2.33107 10.0794 -0.831722 8.08189 2.24782 4.66942C5.32737 1.25695 3.91245 -1.26773 12.2633 2.67187C21.9181 9.13614 33.5149 14.3797 35.9841 16.9321C38.4533 19.4845 42.4484 22.3421 44.113 38.4334C44.113 38.4057 44.6956 42.3453 42.9478 41.4852Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--بازو راست 14-->
    <svg class="vector11" width="19" height="39" viewBox="0 0 19 39" @click="backPartClick(14)" :fill="backFill14"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.21425 35.8777C4.21425 35.8777 4.29749 39.096 6.35052 38.1527C8.40355 37.2094 12.6206 35.8777 15.1175 35.2119C17.6144 34.546 18.53 35.2118 18.53 32.7981C18.53 30.3845 16.7266 6.30296 16.2273 4.49962C15.7279 2.69628 16.0608 0.421298 10.5953 0.948428C5.1298 1.47556 5.12981 4.5551 4.24201 7.32947C3.35421 10.1038 -0.724109 22.4498 1.41215 26.5003C2.82708 31.7161 4.21425 35.8777 4.21425 35.8777Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--بازو چپ  8-->
    <svg class="vector12" width="19" height="38" viewBox="0 0 19 38" @click="backPartClick(8)" :fill="backFill8"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.098 35.3229C15.098 35.3229 15.0147 38.5412 12.9617 37.5979C10.9087 36.6546 6.69163 35.3229 4.1947 34.6571C1.69777 33.9912 0.782227 34.6571 0.782227 32.2434C0.782227 29.8297 2.58557 5.74818 3.08496 3.94484C3.58434 2.1415 3.25141 -0.133481 8.71691 0.393649C14.1824 0.920778 14.1824 4.00032 15.0702 6.77469C15.958 9.54905 20.0363 21.895 17.9001 25.9456C16.4574 31.1614 15.098 35.3229 15.098 35.3229Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--آرنج چپ 9-->
    <svg class="vector13" width="19" height="22" viewBox="0 0 19 22" @click="backPartClick(9)" :fill="backFill9"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.64126 0.485611C6.64126 0.485611 15.1031 2.78833 16.1019 3.06577C17.1006 3.3432 18.8207 3.73161 18.8207 5.72915C18.8207 7.72669 18.3768 15.3285 13.7159 19.9339C13.7159 19.9339 12.9668 21.6818 11.3854 20.8772C9.80404 20.0726 6.16963 16.8821 2.67392 15.9666C1.17577 15.4117 0.232475 14.4684 1.17576 11.7218C2.11904 8.97517 4.56049 3.12125 4.78244 2.09474C5.00438 1.06822 5.05988 0.0694558 6.64126 0.485611Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--آرنج راست 15-->
    <svg class="vector14" width="19" height="22" viewBox="0 0 19 22" @click="backPartClick(15)" :fill="backFill15"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.947 0.485611C12.947 0.485611 4.48522 2.78833 3.48645 3.06577C2.48768 3.3432 0.767578 3.73161 0.767578 5.72915C0.767578 7.72669 1.21148 15.3285 5.87242 19.9339C5.87242 19.9339 6.62149 21.6818 8.20287 20.8772C9.78426 20.0726 13.4187 16.8821 16.9144 15.9666C18.4125 15.4117 19.3558 14.4684 18.4126 11.7218C17.4693 8.97517 15.0278 3.12125 14.8059 2.09474C14.5839 1.06822 14.5562 0.0694558 12.947 0.485611Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ساعد چپ 10-->
    <svg class="vector15" width="24" height="46" viewBox="0 0 24 46" @click="backPartClick(10)" :fill="backFill10"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.01131 0.991865C9.01131 0.991865 17.9725 6.81804 21.0521 6.56835C24.1316 6.31866 23.1606 6.67932 22.4947 9.98082C21.8289 13.2823 16.4189 32.037 13.3393 37.0031C12.9509 39.0562 12.9787 40.9427 12.6457 42.4409C12.3128 43.939 12.2296 45.8256 8.48419 45.0488C4.73879 44.272 -0.14409 42.3577 0.16109 41.3589C0.46627 40.3601 6.8473 1.87967 6.8473 1.87967C6.8473 1.87967 6.87505 -0.145625 9.01131 0.991865Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ساعد راست 16-->
    <svg class="vector16" width="24" height="46" viewBox="0 0 24 46" @click="backPartClick(16)" :fill="backFill16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6987 0.991865C14.6987 0.991865 5.73748 6.81804 2.65794 6.56835C-0.421607 6.31866 0.549417 6.67932 1.21527 9.98082C1.88111 13.2823 7.29113 32.037 10.3707 37.0031C10.7591 39.0562 10.7313 40.9427 11.0643 42.4409C11.3972 43.939 11.4804 45.8256 15.2258 45.0488C18.9712 44.272 23.8541 42.3577 23.5489 41.3589C23.2437 40.3601 16.8627 1.87967 16.8627 1.87967C16.8627 1.87967 16.835 -0.145625 14.6987 0.991865Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--مچ دست چپ 11-->
    <svg class="vector17" width="14" height="10" viewBox="0 0 14 10" @click="backPartClick(11)" :fill="backFill11"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.3571 0.603762C5.03701 2.02561 7.9864 2.86694 11.0131 3.07295C15.9515 3.37813 10.5692 9.81466 10.5692 9.81466C10.5692 9.81466 9.07107 10.3695 6.43542 8.84363C3.79978 7.31773 -0.805673 6.20799 0.442792 2.85101C1.69126 -0.505974 1.10864 -0.00659846 2.3571 0.603762Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--مچ دست راست 17-->
    <svg class="vector18" width="14" height="10" viewBox="0 0 14 10" @click="backPartClick(17)" :fill="backFill17"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1057 0.603762C8.42575 2.02561 5.47636 2.86694 2.44963 3.07295C-2.48874 3.37813 2.89354 9.81466 2.89354 9.81466C2.89354 9.81466 4.39169 10.3695 7.02733 8.84363C9.66298 7.31773 14.2684 6.20799 13.02 2.85101C11.7715 -0.505974 12.3541 -0.00659846 11.1057 0.603762Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کف دست چپ 12-->
    <svg class="vector19" width="19" height="15" viewBox="0 0 19 15" @click="backPartClick(12)" :fill="backFill12"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.19961 0.916691C5.22372 1.55436 0.570152 5.40811 0.03125 6.5629C1.40116 9.47481 6.84804 15.1551 17.6762 14.5808C17.7317 14.4421 19.9235 7.39521 18.3143 5.037L18.2311 4.8428C17.5037 3.38185 12.7954 1.67433 9.56915 0.96679C9.11699 0.867626 8.65225 0.8197 8.19961 0.916691Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کف دست راست 18-->
    <svg class="vector20" width="20" height="15" viewBox="0 0 20 15" @click="backPartClick(18)" :fill="backFill18"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8512 0.916691C13.8271 1.55436 18.4806 5.40811 19.0195 6.5629C17.6496 9.47481 12.2027 15.1551 1.37457 14.5808C1.31908 14.4421 -0.872675 7.39521 0.736456 5.037L0.819693 4.8428C1.54705 3.38185 6.25539 1.67433 9.48163 0.96679C9.9338 0.867626 10.3985 0.8197 10.8512 0.916691Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--انگشتان دست چپ 13-->
    <svg class="vector21" width="23" height="28" viewBox="0 0 23 28" @click="backPartClick(13)" :fill="backFill13"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3898 21.4613C14.0846 22.2936 14.362 23.1814 15.2221 23.4589C15.3968 23.517 15.5815 23.5393 15.7651 23.5244C15.9487 23.5096 16.1274 23.4579 16.2905 23.3724C16.4537 23.287 16.5979 23.1695 16.7146 23.0271C16.8314 22.8846 16.9182 22.7201 16.9699 22.5433L21.9335 8.44064C21.9957 8.264 21.8606 8.07886 21.6733 8.0768C11.4619 7.96451 6.34575 3.42507 4.72725 0.662439C4.60329 0.450835 4.27033 0.470345 4.18816 0.701415L0.850875 10.0864C0.783473 10.2886 0.756551 10.5021 0.771661 10.7148C0.78677 10.9274 0.843608 11.1349 0.938929 11.3255C1.03425 11.5162 1.16619 11.6862 1.32721 11.8258C1.48823 11.9655 1.67518 12.0721 1.87739 12.1395C2.07959 12.2069 2.29309 12.2338 2.5057 12.2187C2.71831 12.2036 2.92586 12.1467 3.1165 12.0514C3.30714 11.9561 3.47714 11.8241 3.61679 11.6631C3.75644 11.5021 3.86301 11.3151 3.93041 11.1129L5.95571 5.20355C5.99617 5.0895 6.08029 4.99619 6.18956 4.94416C6.29882 4.89213 6.42427 4.88564 6.53832 4.92611C6.65237 4.96658 6.74567 5.0507 6.7977 5.15996C6.84973 5.26922 6.85623 5.39467 6.81576 5.50872L1.15605 22.1272C1.08865 22.3294 1.06173 22.5429 1.07684 22.7555C1.09195 22.9681 1.14879 23.1757 1.24411 23.3663C1.33943 23.5569 1.47137 23.7269 1.63239 23.8666C1.79341 24.0062 1.98036 24.1128 2.18257 24.1802C2.38477 24.2476 2.59827 24.2745 2.81088 24.2594C3.02349 24.2443 3.23104 24.1875 3.42168 24.0921C3.61233 23.9968 3.78232 23.8649 3.92197 23.7039C4.06162 23.5428 4.16819 23.3559 4.2356 23.1537L8.11971 11.7788C8.13674 11.727 8.16414 11.6791 8.20023 11.6382C8.23633 11.5973 8.28037 11.5642 8.32968 11.5408C8.37899 11.5174 8.43254 11.5044 8.48706 11.5024C8.54158 11.5003 8.59594 11.5094 8.64683 11.5291C8.74792 11.5684 8.83013 11.645 8.87656 11.743C8.923 11.841 8.93015 11.9531 8.89653 12.0562L4.31883 25.4842C4.18944 25.8927 4.22425 26.3355 4.41589 26.7188C4.60752 27.1021 4.9409 27.3956 5.34534 27.5372C5.75373 27.6726 6.19914 27.6405 6.58396 27.4481C6.96878 27.2557 7.26163 26.9186 7.39837 26.5107L12.0316 12.944C12.072 12.83 12.1562 12.7367 12.2654 12.6846C12.3747 12.6326 12.5001 12.6261 12.6142 12.6666C12.7282 12.7071 12.8215 12.7912 12.8736 12.9004C12.9256 13.0097 12.9321 13.1352 12.8916 13.2492L8.86879 25.0403C8.80139 25.2425 8.77447 25.456 8.78958 25.6686C8.80469 25.8812 8.86153 26.0887 8.95685 26.2794C9.05217 26.47 9.1841 26.64 9.34513 26.7797C9.50615 26.9193 9.69309 27.0259 9.8953 27.0933C10.0975 27.1607 10.311 27.1876 10.5236 27.1725C10.7362 27.1574 10.9438 27.1005 11.1344 27.0052C11.3251 26.9099 11.4951 26.778 11.6347 26.6169C11.7744 26.4559 11.8809 26.269 11.9483 26.0668L16.1931 13.6376C16.2349 13.5415 16.3117 13.4649 16.4079 13.4232C16.5041 13.3816 16.6125 13.378 16.7112 13.4133C16.8099 13.4485 16.8915 13.52 16.9396 13.6131C16.9876 13.7063 16.9984 13.8142 16.9699 13.9151L14.3898 21.4613Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--انگشتان دست راست 19-->
    <svg class="vector22" width="23" height="28" viewBox="0 0 23 28" @click="backPartClick(19)" :fill="backFill19"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.66394 21.4613C8.96912 22.2936 8.69168 23.1814 7.83163 23.4589C7.65686 23.517 7.47218 23.5393 7.28861 23.5244C7.10503 23.5096 6.92634 23.4579 6.7632 23.3724C6.60005 23.287 6.4558 23.1695 6.33907 23.0271C6.22233 22.8846 6.13551 22.7201 6.08378 22.5433L1.12017 8.44064C1.058 8.264 1.19315 8.07886 1.3804 8.0768C11.5918 7.96451 16.708 3.42507 18.3265 0.662439C18.4504 0.450835 18.7834 0.470345 18.8656 0.701415L22.2028 10.0864C22.2702 10.2886 22.2972 10.5021 22.2821 10.7148C22.2669 10.9274 22.2101 11.1349 22.1148 11.3255C22.0195 11.5162 21.8875 11.6862 21.7265 11.8258C21.5655 11.9655 21.3785 12.0721 21.1763 12.1395C20.9741 12.2069 20.7606 12.2338 20.548 12.2187C20.3354 12.2036 20.1278 12.1467 19.9372 12.0514C19.7466 11.9561 19.5766 11.8241 19.4369 11.6631C19.2973 11.5021 19.1907 11.3151 19.1233 11.1129L17.098 5.20355C17.0575 5.0895 16.9734 4.99619 16.8642 4.94416C16.7549 4.89213 16.6294 4.88564 16.5154 4.92611C16.4013 4.96658 16.308 5.0507 16.256 5.15996C16.204 5.26922 16.1975 5.39467 16.238 5.50872L21.8977 22.1272C21.9651 22.3294 21.992 22.5429 21.9769 22.7555C21.9618 22.9681 21.9049 23.1757 21.8096 23.3663C21.7143 23.5569 21.5823 23.7269 21.4213 23.8666C21.2603 24.0062 21.0733 24.1128 20.8711 24.1802C20.6689 24.2476 20.4554 24.2745 20.2428 24.2594C20.0302 24.2443 19.8227 24.1875 19.632 24.0921C19.4414 23.9968 19.2714 23.8649 19.1317 23.7039C18.9921 23.5428 18.8855 23.3559 18.8181 23.1537L14.934 11.7788C14.917 11.727 14.8896 11.6791 14.8535 11.6382C14.8174 11.5973 14.7733 11.5642 14.724 11.5408C14.6747 11.5174 14.6212 11.5044 14.5667 11.5024C14.5121 11.5003 14.4578 11.5094 14.4069 11.5291C14.3058 11.5684 14.2236 11.645 14.1771 11.743C14.1307 11.841 14.1236 11.9531 14.1572 12.0562L18.7349 25.4842C18.8643 25.8927 18.8295 26.3355 18.6378 26.7188C18.4462 27.1021 18.1128 27.3956 17.7084 27.5372C17.3 27.6726 16.8546 27.6405 16.4698 27.4481C16.0849 27.2557 15.7921 26.9186 15.6553 26.5107L11.0221 12.944C10.9817 12.83 10.8976 12.7367 10.7883 12.6846C10.679 12.6326 10.5536 12.6261 10.4395 12.6666C10.3255 12.7071 10.2322 12.7912 10.1802 12.9004C10.1281 13.0097 10.1216 13.1352 10.1621 13.2492L14.1849 25.0403C14.2523 25.2425 14.2792 25.456 14.2641 25.6686C14.249 25.8812 14.1922 26.0887 14.0969 26.2794C14.0015 26.47 13.8696 26.64 13.7086 26.7797C13.5476 26.9193 13.3606 27.0259 13.1584 27.0933C12.9562 27.1607 12.7427 27.1876 12.5301 27.1725C12.3175 27.1574 12.1099 27.1005 11.9193 27.0052C11.7287 26.9099 11.5587 26.778 11.419 26.6169C11.2793 26.4559 11.1728 26.269 11.1054 26.0668L6.8606 13.6376C6.81877 13.5415 6.742 13.4649 6.64582 13.4232C6.54964 13.3816 6.44123 13.378 6.34253 13.4133C6.24383 13.4485 6.1622 13.52 6.11416 13.6131C6.06612 13.7063 6.05527 13.8142 6.08378 13.9151L8.66394 21.4613Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--زانو چپ 29-->
    <svg class="vector23" width="21" height="27" viewBox="0 0 21 27" @click="backPartClick(29)" :fill="backFill29"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.288086 0.833553C0.288086 0.833553 14.7148 4.32926 18.6821 0.944535C22.6495 -2.44019 19.5422 25.5254 17.7666 26.0525C15.991 26.5797 14.3541 26.2745 10.4423 26.2468C6.5304 26.219 0.981674 26.6906 1.48106 21.3639C1.98045 16.0371 0.454548 1.80458 0.288086 0.833553Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!-- زانو راست 30-->
    <svg class="vector24" width="22" height="27" viewBox="0 0 22 27" @click="backPartClick(30)" :fill="backFill30"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.0775 0.833553C21.0775 0.833553 6.65075 4.32926 2.68341 0.944535C-1.28394 -2.44019 1.82335 25.5254 3.59895 26.0525C5.37454 26.5797 7.01142 26.2745 10.9233 26.2468C14.8351 26.219 20.3839 26.6906 19.8845 21.3639C19.3851 16.0371 20.911 1.80458 21.0775 0.833553Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ساق پا راست 32-->
    <svg class="vector25" width="22" height="59" viewBox="0 0 22 59" @click="backPartClick(32)" :fill="backFill32"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.11151 1.29723L18.6794 0.520391C18.6794 0.520391 22.5913 -0.589362 21.5925 2.35147C21.4815 6.34655 20.3718 31.0384 12.9919 55.1754C12.4648 56.7845 12.2151 57.3671 11.9377 57.811C11.6602 58.2549 11.6048 58.7266 10.6337 57.6446C9.66271 56.5626 5.88956 53.3998 3.58684 52.7062C1.28412 52.0126 1.28411 50.6532 1.25637 50.2093C1.22862 49.7654 -0.10306 21.7998 1.06217 18.7202C1.70028 13.5599 2.97648 4.29352 2.97648 4.29352C2.97648 4.29352 2.75452 1.60241 6.11151 1.29723Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ساق پا چپ 31-->
    <svg class="vector26" width="21" height="59" viewBox="0 0 21 59" @click="backPartClick(31)" :fill="backFill31"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0213 2.79658L4.64759 0.577091C4.64759 0.577091 0.9022 -0.97654 1.5403 2.04752C1.17964 6.01486 -0.568219 30.679 3.954 55.5095C4.28692 57.1741 4.48113 57.7845 4.70308 58.2284C4.92503 58.6723 4.95278 59.1717 6.00703 58.2284C7.06129 57.2851 11.1951 54.5663 13.5811 54.1501C15.967 53.734 16.1057 52.4023 16.189 51.9584C16.2722 51.5145 20.8499 23.8818 20.0453 20.6912C20.0176 15.5032 19.8234 6.15359 19.8234 6.15359C19.8234 6.15359 20.295 3.49017 17.0213 2.79658Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کف پای چپ 35-->
    <svg class="vector27" width="14" height="26" viewBox="0 0 14 26" @click="backPartClick(35)" :fill="backFill35"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.97014 8.83961C1.97014 12.5079 1.70884 14.4381 0.394849 16.3406C0.341979 16.4171 0.323258 16.5168 0.344268 16.6075C3.00473 28.0834 8.6828 25.8184 11.4987 24.6938C11.6165 24.6468 11.6689 24.5119 11.6148 24.3972C10.7735 22.6146 8.89957 17.7951 10.7094 14.3883C12.596 10.8372 13.1508 7.17499 13.2063 5.78781C12.9844 4.26191 11.6804 1.04364 8.35118 0.377793C4.18963 -0.454517 1.97014 5.09421 1.97014 8.83961Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کف پای راست 36-->
    <svg class="vector28" width="14" height="26" viewBox="0 0 14 26" @click="backPartClick(36)" :fill="backFill36"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7056 8.83961C11.7056 12.5079 11.9669 14.4381 13.2809 16.3406C13.3338 16.4171 13.3525 16.5168 13.3315 16.6075C10.671 28.0834 4.99298 25.8184 2.17705 24.6938C2.05931 24.6468 2.00685 24.5119 2.06095 24.3972C2.90224 22.6146 4.77622 17.7951 2.96639 14.3883C1.07982 10.8372 0.524946 7.17499 0.469459 5.78781C0.691408 4.26191 1.99536 1.04364 5.3246 0.377793C9.48615 -0.454517 11.7056 5.09421 11.7056 8.83961Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--انگشتان پای چپ 37-->
    <svg class="vector29" width="20" height="25" viewBox="0 0 20 25" @click="backPartClick(37)" :fill="backFill37"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.9294 24.3517C18.594 23.6304 19.1766 22.5761 19.2598 21.4663C19.3708 19.8295 18.3165 18.0816 17.8172 17.1938C17.8172 17.1661 17.7894 17.1661 17.7894 17.1383C17.2965 16.2723 17.0115 15.3035 16.9571 14.3085C17.0126 14.2808 17.0403 14.253 17.0958 14.2253C19.5774 12.5273 18.6895 8.09943 17.9983 6.89281C17.937 6.78585 17.7981 6.77415 17.7048 6.85472C14.3584 9.74428 7.20582 12.3249 3.76713 0.791846C3.71532 0.618078 3.49213 0.573947 3.4117 0.736465C2.65152 2.27264 2.56283 5.40342 2.61362 7.5113C2.61347 8.18036 2.42085 8.83524 2.05875 9.39785C1.75357 9.814 1.47613 10.2302 1.25418 10.5076C0.727055 11.1734 0.449619 13.1155 0.421875 13.6426V13.6981C1.11547 15.3627 2.78009 14.253 2.78009 13.0045V12.4497C2.80783 11.7006 2.97429 11.5896 3.88983 11.4786C4.2505 11.4509 4.36147 11.6728 4.36147 12.0058V12.089C4.33373 12.7271 3.86209 13.7536 3.88983 13.7536C3.3627 14.1975 2.80782 16.1396 2.55813 17.1938C2.53391 17.2651 2.52447 17.3407 2.53039 17.4158C2.5581 17.582 2.58582 17.7206 2.61353 17.8592L2.61362 17.8597C2.61362 17.8874 2.61362 17.8874 2.64137 17.9429C2.66911 17.9984 2.66911 18.0539 2.69685 18.1094C2.89106 18.6365 3.14075 18.8862 3.44593 18.9694H3.47368C3.83435 19.0249 4.25049 18.7752 4.61116 18.581C4.74988 18.4978 4.8886 18.4423 4.99958 18.3868C5.02732 18.3591 5.08281 18.3313 5.11055 18.3036C5.47122 17.8042 5.24927 16.5557 5.3325 15.4737C5.36024 15.2795 5.38799 15.0853 5.41573 14.9188C5.5513 14.8079 5.71274 14.7331 5.88502 14.7014C6.05729 14.6697 6.23479 14.6821 6.40097 14.7375C6.56715 14.7929 6.7166 14.8894 6.8354 15.0182C6.95419 15.1469 7.03846 15.3036 7.08035 15.4737C7.10319 15.5454 7.11259 15.6206 7.10809 15.6957C7.10809 16.2783 6.58097 17.3048 5.83189 18.4423C5.39761 19.0571 5.12997 19.774 5.05506 20.5231V20.7173C5.06011 20.9984 5.13346 21.2741 5.2688 21.5206C5.40413 21.7671 5.59738 21.977 5.83189 22.1322C7.63523 23.1865 8.13461 21.1612 8.1901 19.8295V19.663C8.1901 19.5243 8.16236 19.3578 8.16236 19.1636V18.5533C8.1901 17.7487 8.35656 16.8054 8.88369 16.4447C9.60503 15.9176 10.1044 16.5835 10.1322 17.2216V17.2771C10.1426 17.4805 10.0944 17.6827 9.99344 17.8597C9.48121 18.7703 9.10721 19.7521 8.88369 20.7728C8.83457 21.0849 8.80676 21.4001 8.80046 21.716V22.0212C8.8282 22.9645 9.16113 24.0465 10.4096 24.324C11.9355 24.6569 12.5181 23.2419 12.5736 22.1877V22.0212C12.5796 21.8327 12.5514 21.6447 12.4904 21.4663C12.2541 20.588 12.1237 19.6845 12.1019 18.7752V18.0539C12.1202 17.7467 12.1573 17.441 12.2129 17.1383C12.8788 15.6957 13.7943 16.528 14.155 17.1383C14.1102 17.2371 14.0731 17.3391 14.044 17.4435C14.044 17.4713 14.0163 17.4713 14.0163 17.499C14.0181 17.5468 14.0086 17.5943 13.9885 17.6377C13.8221 18.1649 13.6833 18.7197 13.4614 21.3554V21.827C13.5724 24.0188 15.7641 24.4349 16.9294 24.3517Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--انگشتان پای راست 38-->
    <svg class="vector30" width="20" height="25" viewBox="0 0 20 25" @click="backPartClick(38)" :fill="backFill38"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.74545 24.3517C1.08083 23.6304 0.498224 22.5761 0.414993 21.4663C0.304018 19.8295 1.35826 18.0816 1.85765 17.1938C1.85765 17.1661 1.8854 17.1661 1.8854 17.1383C2.37834 16.2723 2.66327 15.3035 2.71771 14.3085C2.66223 14.2808 2.63448 14.253 2.57899 14.2253C0.0974312 12.5273 0.985332 8.09943 1.67655 6.89281C1.73782 6.78585 1.87667 6.77415 1.96997 6.85472C5.31636 9.74428 12.469 12.3249 15.9077 0.791846C15.9595 0.618078 16.1827 0.573947 16.2631 0.736465C17.0233 2.27264 17.112 5.40342 17.0612 7.5113C17.0613 8.18036 17.254 8.83524 17.6161 9.39785C17.9212 9.814 18.1987 10.2302 18.4206 10.5076C18.9477 11.1734 19.2252 13.1155 19.2529 13.6426V13.6981C18.5593 15.3627 16.8947 14.253 16.8947 13.0045V12.4497C16.867 11.7006 16.7005 11.5896 15.785 11.4786C15.4243 11.4509 15.3133 11.6728 15.3133 12.0058V12.089C15.3411 12.7271 15.8127 13.7536 15.785 13.7536C16.3121 14.1975 16.867 16.1396 17.1167 17.1938C17.1409 17.2651 17.1503 17.3407 17.1444 17.4158C17.1167 17.582 17.089 17.7206 17.0613 17.8592L17.0612 17.8597C17.0612 17.8874 17.0612 17.8874 17.0334 17.9429C17.0057 17.9984 17.0057 18.0539 16.978 18.1094C16.7837 18.6365 16.5341 18.8862 16.2289 18.9694H16.2011C15.8405 19.0249 15.4243 18.7752 15.0636 18.581C14.9249 18.4978 14.7862 18.4423 14.6752 18.3868C14.6475 18.3591 14.592 18.3313 14.5643 18.3036C14.2036 17.8042 14.4255 16.5557 14.3423 15.4737C14.3146 15.2795 14.2868 15.0853 14.2591 14.9188C14.1235 14.8079 13.9621 14.7331 13.7898 14.7014C13.6175 14.6697 13.44 14.6821 13.2738 14.7375C13.1077 14.7929 12.9582 14.8894 12.8394 15.0182C12.7206 15.1469 12.6363 15.3036 12.5945 15.4737C12.5716 15.5454 12.5622 15.6206 12.5667 15.6957C12.5667 16.2783 13.0938 17.3048 13.8429 18.4423C14.2772 19.0571 14.5448 19.774 14.6197 20.5231V20.7173C14.6147 20.9984 14.5413 21.2741 14.406 21.5206C14.2707 21.7671 14.0774 21.977 13.8429 22.1322C12.0396 23.1865 11.5402 21.1612 11.4847 19.8295V19.663C11.4847 19.5243 11.5124 19.3578 11.5124 19.1636V18.5533C11.4847 17.7487 11.3182 16.8054 10.7911 16.4447C10.0698 15.9176 9.57039 16.5835 9.54265 17.2216V17.2771C9.53223 17.4805 9.58037 17.6827 9.68137 17.8597C10.1936 18.7703 10.5676 19.7521 10.7911 20.7728C10.8402 21.0849 10.868 21.4001 10.8743 21.716V22.0212C10.8466 22.9645 10.5137 24.0465 9.26521 24.324C7.73931 24.6569 7.1567 23.2419 7.10121 22.1877V22.0212C7.09517 21.8327 7.12337 21.6447 7.18444 21.4663C7.4207 20.588 7.5511 19.6845 7.57285 18.7752V18.0539C7.55462 17.7467 7.51755 17.441 7.46187 17.1383C6.79603 15.6957 5.88048 16.528 5.51982 17.1383C5.5646 17.2371 5.60171 17.3391 5.6308 17.4435C5.6308 17.4713 5.65854 17.4713 5.65854 17.499C5.65669 17.5468 5.66619 17.5943 5.68628 17.6377C5.85274 18.1649 5.99146 18.7197 6.21341 21.3554V21.827C6.10243 24.0188 3.91068 24.4349 2.74545 24.3517Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--مچ پای چپ 33-->
    <svg class="vector31" width="14" height="17" viewBox="0 0 14 17" @click="backPartClick(33)" :fill="backFill33"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.08824 6.72402C1.08824 6.72402 8.19062 1.34175 9.46683 1.17529C10.743 1.00883 11.7696 -0.18414 12.158 3.22833C12.5464 6.6408 13.5451 14.9916 13.5451 14.9916C13.5451 14.9916 7.52477 13.327 3.55742 16.2124C3.05804 16.4343 3.05804 14.9084 2.66963 12.9109C2.28122 10.9133 0.339159 7.2789 1.08824 6.72402Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--مچ پای راست 34-->
    <svg class="vector32" width="14" height="17" viewBox="0 0 14 17" @click="backPartClick(34)" :fill="backFill34"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.87 6.72402C12.87 6.72402 5.7676 1.34175 4.49139 1.17529C3.21518 1.00883 2.18868 -0.18414 1.80027 3.22833C1.41186 6.6408 0.413086 14.9916 0.413086 14.9916C0.413086 14.9916 6.43346 13.327 10.4008 16.2124C10.9002 16.4343 10.9002 14.9084 11.2886 12.9109C11.677 10.9133 13.6191 7.2789 12.87 6.72402Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--سر 1-->
    <svg class="vector33" width="33" height="39" viewBox="0 0 33 39" @click="backPartClick(1)" :fill="backFill1"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.59555 7.29447C4.59555 7.29447 12.4747 -3.22037 23.4057 2.35611C26.0254 3.70517 28.2509 5.70999 29.8651 8.17512C31.4794 10.6403 32.4273 13.4816 32.6166 16.4221C33.1993 25.1614 28.8435 33.9284 26.1524 35.8427C19.9101 40.3094 10.4495 39.5881 6.45438 35.6485C3.48581 32.6799 -3.39462 17.2544 4.59555 7.29447Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--گردن 2-->
    <svg class="group-33347" width="18" height="31" viewBox="0 0 18 31" @click="backPartClick(2)" :fill="backFill2"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M5.23242 2.94574V26.8427" stroke="#5A5A5A" stroke-width="0.543113" />
      <path d="M12.6689 3.76041V27.1143" stroke="#5A5A5A" stroke-width="0.543113" />
      <path
        d="M17.1493 1.13485C10.9713 6.39287 4.22918 3.15468 0.575634 1.00911C0.416954 0.915925 0.220308 1.04831 0.245736 1.23056C1.21877 8.20467 0.178711 16.5936 0.178711 19.7823C0.178711 22.2416 5.33403 27.4718 8.34984 29.7283C8.66639 29.9652 9.09 29.9959 9.43108 29.7959C12.8177 27.811 15.4839 23.6206 16.8791 21.0776C17.3269 20.2615 17.3744 19.2813 17.2687 18.3565C16.8457 14.6577 17.2173 6.10959 17.5231 1.31394C17.5356 1.11836 17.2985 1.00783 17.1493 1.13485Z"
        stroke="#212121" stroke-width="0.695184" />
    </svg>
    <!--ستون فقرات اولی 5    rectangle-7037-->
    <div :class="backFill5" :style="backgroundColor5" @click="backPartClick(5)"></div>
    <!--ستون فقرات دومی 6    rectangle-7039-->
    <div :class="backFill6" :style="backgroundColor6" @click="backPartClick(6)"></div>
    <!-- ستون فقرات سومی7    rectangle-7038-->
    <div :class="backFill7" :style="backgroundColor7" @click="backPartClick(7)"></div>
    <!-- ستون فقرات چهارمی 24    rectangle-7040-->
    <div :class="backFill24" :style="backgroundColor24" @click="backPartClick(24)"></div>
  </div>
</template>
<script>
import HumanBackHelper from '@/Helpers/FollowUp/HumanBackHelper';
export default {
  mixins: [HumanBackHelper],
  created() {
    this.$root.$refs.HumanBack1 = this;
  },
  mounted() {
    this.$emit('showData', this.test);
  },
  data() {
    return {};
  },
  props: {
    hasBackClick: {
      type: Boolean,
      require: true,
      default: false,
    },
    data: {
      type: Array,
      require: false,
      default: () => [],
    },
  },
  methods: {
    test: function () {
      this.backFill12 = 'red';
    },
  },
};
</script>
<style scoped>
.txtStyle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding: 5px 10px;
  color: white;
  background-color: var(--dark-color);
  border-radius: 4px;
  position: absolute;
  left: 223.7px;
  top: 0;
  overflow: visible;
}

.vector {
  position: absolute;
  left: 220.49px;
  top: 294.45px;
  overflow: visible;
}

.vector2 {
  position: absolute;
  left: 257.5px;
  top: 294.45px;
  overflow: visible;
}

.vector3 {
  position: absolute;
  left: 221.62px;
  top: 249.77px;
  overflow: visible;
}

.vector4 {
  position: absolute;
  left: 256.42px;
  top: 249.77px;
  overflow: visible;
}

.vector5 {
  position: absolute;
  left: 225.43px;
  top: 229.75px;
  overflow: visible;
}

.vector6 {
  position: absolute;
  left: 260.59px;
  top: 230.33px;
  overflow: visible;
}

.vector7 {
  position: absolute;
  left: 256.69px;
  top: 147.76px;
  transform: translate(2.69px, -0.62px);
  overflow: visible;
}

.vector8 {
  position: absolute;
  left: 217.88px;
  top: 147.76px;
  overflow: visible;
}

.vector9 {
  position: absolute;
  left: 202.74px;
  top: 135.81px;
  overflow: visible;
}

.vector10 {
  position: absolute;
  left: 262px;
  top: 135.81px;
  overflow: visible;
}

.vector11 {
  position: absolute;
  left: 288.63px;
  top: 180.01px;
  overflow: visible;
}

.vector12 {
  position: absolute;
  left: 199.61px;
  top: 179.46px;
  overflow: visible;
}

.vector13 {
  position: absolute;
  left: 195.63px;
  top: 217.53px;
  overflow: visible;
}

.vector14 {
  position: absolute;
  left: 292.6px;
  top: 217.53px;
  overflow: visible;
}

.vector15 {
  position: absolute;
  left: 185.98px;
  top: 234.79px;
  overflow: visible;
}

.vector16 {
  position: absolute;
  left: 297.36px;
  top: 234.79px;
  overflow: visible;
}

.vector17 {
  position: absolute;
  left: 183.06px;
  top: 279.3px;
  overflow: visible;
}

.vector18 {
  position: absolute;
  left: 309.2px;
  top: 279.3px;
  overflow: visible;
}

.vector19 {
  border-radius: 0px;
  position: absolute;
  left: 173.86px;
  top: 288.97px;
  overflow: visible;
}

.vector20 {
  border-radius: 0px;
  position: absolute;
  left: 330.85px;
  top: 288.97px;
  transform: translate(-19.28px, -0.37px);
  overflow: visible;
}

.vector21 {
  border-radius: 0px;
  position: absolute;
  left: 168.6px;
  top: 298.2px;
  overflow: visible;
}

.vector22 {
  border-radius: 0px;
  position: absolute;
  left: 336.12px;
  top: 298.2px;
  transform: translate(-21.59px, 0.05px);
  overflow: visible;
}

.vector23 {
  position: absolute;
  left: 227.12px;
  top: 363.8px;
  overflow: visible;
}

.vector24 {
  position: absolute;
  left: 258.59px;
  top: 363.8px;
  overflow: visible;
}

.vector25 {
  position: absolute;
  left: 256.42px;
  top: 392.46px;
  overflow: visible;
}

.vector26 {
  position: absolute;
  left: 226.74px;
  top: 391.32px;
  overflow: visible;
}

.vector27 {
  border-radius: 0px;
  position: absolute;
  left: 232.14px;
  top: 463.44px;
  overflow: visible;
}

.vector28 {
  border-radius: 0px;
  position: absolute;
  left: 266.2px;
  top: 463.44px;
  transform: translate(-13.3px, -0.41px);
  overflow: visible;
}

.vector29 {
  border-radius: 0px;
  position: absolute;
  left: 227.25px;
  top: 483.49px;
  overflow: visible;
}

.vector30 {
  border-radius: 0px;
  position: absolute;
  left: 271.08px;
  top: 483.49px;
  transform: translate(-19.25px, -0.13px);
  overflow: visible;
}

.vector31 {
  position: absolute;
  left: 231.75px;
  top: 446.98px;
  overflow: visible;
}

.vector32 {
  position: absolute;
  left: 254.24px;
  top: 446.98px;
  overflow: visible;
}

.vector33 {
  position: absolute;
  left: 238.7px;
  top: 72.87px;
  overflow: visible;
}

.group-33347 {
  position: absolute;
  left: 245.01px;
  top: 111.91px;
  overflow: visible;
}

.rectangle-7037 {
  border-radius: 10.86px 10.86px 0px 0px;
  border-style: solid;
  border-color: #212121;
  border-width: 0.81px;
  width: 8.69px;
  height: 28.24px;
  position: absolute;
  left: 249.98px;
  top: 144.5px;
}

.rectangle-7037-fill {
  border-radius: 10.86px 10.86px 0px 0px;
  border-style: solid;
  border-color: #212121;
  border-width: 0.81px;
  width: 8.69px;
  height: 28.24px;
  position: absolute;
  left: 249.98px;
  top: 144.5px;
  background: #ef50cc;
}

.rectangle-7039 {
  border-style: solid;
  border-color: #212121;
  border-width: 0.81px;
  width: 8.69px;
  height: 22.81px;
  position: absolute;
  left: 249.98px;
  top: 174.92px;
}

.rectangle-7039-fill {
  border-style: solid;
  border-color: #212121;
  border-width: 0.81px;
  width: 8.69px;
  height: 22.81px;
  position: absolute;
  left: 249.98px;
  top: 174.92px;
  background: #0a6ada;
}

.rectangle-7038 {
  border-radius: 10.86px 10.86px 0px 0px;
  border-style: solid;
  border-color: #212121;
  border-width: 0.81px;
  width: 8.69px;
  height: 28.24px;
  position: absolute;
  left: 258.67px;
  top: 228.14px;
  transform-origin: 0 0;
  transform: rotate(-180deg) scale(1, 1);
}

.rectangle-7038-fill {
  border-radius: 10.86px 10.86px 0px 0px;
  border-style: solid;
  border-color: #212121;
  border-width: 0.81px;
  width: 8.69px;
  height: 28.24px;
  position: absolute;
  left: 258.67px;
  top: 228.14px;
  transform-origin: 0 0;
  transform: rotate(-180deg) scale(1, 1);
  background: #f2bd27;
}

.rectangle-7040 {
  border-radius: 10.86px;
  border-style: solid;
  border-color: #212121;
  border-width: 0.81px;
  width: 8.69px;
  height: 38.02px;
  position: absolute;
  left: 258.67px;
  top: 268.33px;
  transform-origin: 0 0;
  transform: rotate(-180deg) scale(1, 1);
}

.rectangle-7040-fill {
  border-radius: 10.86px;
  border-style: solid;
  border-color: #212121;
  border-width: 0.81px;
  width: 8.69px;
  height: 38.02px;
  position: absolute;
  left: 258.67px;
  top: 268.33px;
  transform-origin: 0 0;
  transform: rotate(-180deg) scale(1, 1);
  background: #d05e24;
}
</style>
